import { useSelector } from "react-redux";

import CountryService from "app/services/CountryService";

import CrmEnrichmentJobSettingsWizardStep from "../../../components/wizard/CrmEnrichmentJobSettingsWizardStep";
import { useCrmEnrichmentContext } from "../../../contexts/CrmEnrichmentContext";
import useJobSettingsActions from "../../../hooks/wizard/useJobSettingsActions";
import { selectJobState } from "../../../store/selectors";
import type { CrmEnrichmentJobObject } from "../../../types/types";

type Props = {
    jobObjectOptions: readonly CrmEnrichmentJobObject[];
    onSelectJobObject: (object: CrmEnrichmentJobObject) => void;
};

const CrmEnrichmentJobSettingsWizardStepContainer = ({ jobObjectOptions, onSelectJobObject }: Props) => {
    const { crmProvider, i18nKeys } = useCrmEnrichmentContext();

    const { jobType, jobObject, refreshPeriod, leadScoreRefreshDataInterval, countryId, enrichmentSource } =
        useSelector(selectJobState);

    const settingsActions = useJobSettingsActions({ crmProvider, onSelectJobObject });

    return (
        <CrmEnrichmentJobSettingsWizardStep
            selectedCountry={CountryService.getCountryById(countryId)}
            selectedJobType={jobType}
            selectedJobObject={jobObject}
            selectedJobRefreshPeriod={refreshPeriod}
            selectedLeadScoreRefreshDataInterval={leadScoreRefreshDataInterval}
            selectedEnrichmentSource={enrichmentSource}
            jobObjectOptions={jobObjectOptions}
            translationKeys={i18nKeys}
            {...settingsActions}
        />
    );
};

export default CrmEnrichmentJobSettingsWizardStepContainer;
